import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMerchantOrderSharedLinksForEventExportQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;


export type GetMerchantOrderSharedLinksForEventExportQuery = { __typename?: 'Query', getMerchantOrderSharedLinksForEvent: { __typename?: 'GetMerchantOrderSharedLinksForEventResponse', total: number, eventMerchantorderSharedLinks: Array<{ __typename?: 'MerchantOrderSharedLink', id: string, sales_order_url?: string | null, event_account?: { __typename?: 'EventAccount', id: string, name?: string | null } | null, merchant_order?: { __typename?: 'MerchantOrderInfo', status: Types.MerchantOrderStatusEnum, comment?: string | null, latest_revision?: { __typename?: 'MerchantOrderRevisionInfo', containers: Array<{ __typename?: 'MerchantOrderContainerInfo', type_id: number, amount_int: number, unit: Types.MerchantOrderItemUnit, container_type?: { __typename?: 'ContainerType', id: number, name: string, packing_unit?: number | null } | null }> } | null } | null }> } };


export const GetMerchantOrderSharedLinksForEventExportDocument = gql`
    query GetMerchantOrderSharedLinksForEventExport($eventId: ID!) {
  getMerchantOrderSharedLinksForEvent(event_id: $eventId) {
    total
    eventMerchantorderSharedLinks {
      id
      sales_order_url
      event_account {
        id
        name
      }
      merchant_order {
        status
        comment
        latest_revision {
          containers {
            type_id
            amount_int
            unit
            container_type {
              id
              name
              packing_unit
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMerchantOrderSharedLinksForEventExportQuery__
 *
 * To run a query within a React component, call `useGetMerchantOrderSharedLinksForEventExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantOrderSharedLinksForEventExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantOrderSharedLinksForEventExportQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetMerchantOrderSharedLinksForEventExportQuery(baseOptions: Apollo.QueryHookOptions<GetMerchantOrderSharedLinksForEventExportQuery, GetMerchantOrderSharedLinksForEventExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantOrderSharedLinksForEventExportQuery, GetMerchantOrderSharedLinksForEventExportQueryVariables>(GetMerchantOrderSharedLinksForEventExportDocument, options);
      }
export function useGetMerchantOrderSharedLinksForEventExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantOrderSharedLinksForEventExportQuery, GetMerchantOrderSharedLinksForEventExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantOrderSharedLinksForEventExportQuery, GetMerchantOrderSharedLinksForEventExportQueryVariables>(GetMerchantOrderSharedLinksForEventExportDocument, options);
        }
export type GetMerchantOrderSharedLinksForEventExportQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventExportQuery>;
export type GetMerchantOrderSharedLinksForEventExportLazyQueryHookResult = ReturnType<typeof useGetMerchantOrderSharedLinksForEventExportLazyQuery>;
export type GetMerchantOrderSharedLinksForEventExportQueryResult = Apollo.QueryResult<GetMerchantOrderSharedLinksForEventExportQuery, GetMerchantOrderSharedLinksForEventExportQueryVariables>;